<template>
  <div class="app-container">
    <CrudTable entity="PrintTemplate" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'name',
        { field: 'productGroupDescription', label: 'printTemplate.productGroup' },
        { field: 'productTypeDescription', label: 'common.productType' },
        {
          field: 'printerTypeOption',
          label: 'printer.typeOption',
          formatter: this.formatPrinterType,
          filter: {
            type: 'select',
            options: this.$store.getters['option/loadedOptions']('printerType'),
            valueField: 'code',
            labelField: 'description'
          }
        }
      ]
    };
  },
  methods: {
    generateSummary({ name }) {
      return `${name}`;
    },
    formatPrinterType(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('printerType').find(item => item.code === cellValue);
      return option && option.description;
    }
  }
};
</script>
